export default __webpack_public_path__ + "static/media/opensea.21f982a5.svg";